// import { Button } from "@/components/ui/button";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import {
  useDeleteFAQ,
  useGetAllFAQ,
} from "@/services/faq.service";
import React from "react";
import { toast } from "react-toastify";

interface ReviewModalProps {
  open: boolean;
  onClose: () => void;
  faqId: string;
}

const DeleteModal: React.FC<ReviewModalProps> = ({ faqId, onClose, open }) => {
  const { refetch, isError } = useGetAllFAQ({
    page: 1,
    pageSize: 10,
  });

  const { mutate: deleteFAQ } = useDeleteFAQ();

  function handleSubmit() {
    deleteFAQ(faqId, {
      onSuccess: () => {
        console.log("FAQ Deleted");
        if (!isError) {
          refetch();
        }
        toast.success("FAQ deleted");
        onClose();
      },
      onError: (error) => {
        console.error(error);
        toast.error("Error when deleting the FAQ");
        onClose();
      },
    });
  }

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="w-[320px] rounded-2xl border border-white/10 bg-[#14142A] p-2 text-white">
        <div className="flex flex-col px-5 py-5">
          <div className="w-full text-center text-2xl font-normal text-white max-sm:hidden">
            Are You Sure You Want <br /> to Delete This <br /> FAQ?
          </div>
          <div className="w-full text-center text-2xl font-normal text-white sm:hidden">
            Are You Sure You Want to Delete This FAQ?
          </div>
          <div className="w-full pt-[24px] text-center text-sm font-light text-white">
            Deleting this FAQ will remove it permanently from your site. This
            action cannot be undone. Please confirm if you wish to proceed.
          </div>
        </div>
        <div className="px-5 py-3">
          <button
            className="w-full rounded-md bg-[#FF5E5E] py-2"
            onClick={handleSubmit}
          >
            Delete
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteModal;
